import { render } from "./BusinessHoursEdit.vue?vue&type=template&id=19e31fb7"
import script from "./BusinessHoursEdit.vue?vue&type=script&lang=js"
export * from "./BusinessHoursEdit.vue?vue&type=script&lang=js"

import "./BusinessHoursEdit.vue?vue&type=style&index=0&id=19e31fb7&lang=css"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__